// extracted by mini-css-extract-plugin
export default {"PillActive":"PillCellRenderer_PillActive__bJ+bo","PillInactive":"PillCellRenderer_PillInactive__4JK44"};